// Components==============
import React, { createContext, useMemo, useState } from 'react';
import { RootDreamModal } from 'typings';
// =========================

type GlobalRootDreamContextType = {
  rootDreamModal: RootDreamModal;
  setRootDreamModal: React.Dispatch<React.SetStateAction<RootDreamModal>>;
};

export const GlobalRootDreamContext = createContext(
  {} as GlobalRootDreamContextType
);

export default function GlobalRootDream({
  children,
}: {
  children: React.ReactNode;
}) {
  const [rootDreamModal, setRootDreamModal] = useState<RootDreamModal>(
    undefined
  );

  const value = useMemo(
    () => ({
      rootDreamModal,
      setRootDreamModal,
    }),
    [rootDreamModal]
  );

  return (
    <GlobalRootDreamContext.Provider value={value}>
      {children}
    </GlobalRootDreamContext.Provider>
  );
}
